<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.systemParameters.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/systemParameters"><span>{{$t('tlt.systemParameters')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/systemParameters/edit"><span>{{$t('tlt.systemParameters.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('systemParameters')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>Cancel</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.code')}}:</label>
                                <input 
                                v-validate="'required'"
                                name="code"
                                :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('code') }"
                                v-model="code" type="text">
                               <span v-show="errors.has('code')" class="lbl-obg">
                                    {{ errors.first('code') }}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.group')}}:</label>
                                <select 
                                :class="{'form-control': true, 'is-invalid': errors.has('group') }"
                                v-model="group"
                                v-validate="'required'"
                                name="group">
                                    <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="S">{{ $t("lbl.systemParameters.system") }}</option>
                                    <option value="E">{{ $t("lbl.systemParameters.endPoint") }}</option>
                                    <option value="F">{{ $t("lbl.systemParameters.functional") }}</option>
                                    <option value="Y">{{ $t("lbl.systemParameters.synchronous") }}</option>
                                    <option value="A">{{ $t("lbl.systemParameters.asynchronous") }}</option>
                                </select>
                                <span v-show="errors.has('group')" class="lbl-obg">
                                    {{ errors.first('group') }}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.systemParameter.dataType')}}:</label>
                                <select 
                                :class="{'form-control': true, 'is-invalid': errors.has('dataType') }"
                                v-validate="'required'"
                                name="dataType"
                                v-on:change="changeEditor(this)" v-model="dataType">
                                    <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="T">{{ $t("lbl.systemParameters.text") }}</option>
                                    <option value="D">{{ $t("lbl.basic.date") }}</option>
                                    <option value="N">{{ $t("lbl.systemParameters.number") }}</option>
                                    <option value="J">{{ $t("lbl.systemParameters.json") }}</option>
                                    <option value="X">{{ $t("lbl.systemParameters.xml") }}</option>
                                    <option value="U">{{ $t("lbl.systemParameters.url") }}</option>
                                    <option value="B">{{ $t("lbl.systemParameters.boolean") }}</option>
                                    <option value="P">{{ $t("lbl.systemParameters.properties") }}</option>
                                    <option value="Y">{{ $t("lbl.systemParameters.yml") }}</option>
                                </select>
                                <span v-show="errors.has('dataType')" class="lbl-obg">
                                    {{ errors.first('dataType') }}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.active')}}:</label>
                                <select 
                                :class="{'form-control': true, 'is-invalid': errors.has('active') }"
                                v-validate="'required'"
                                name="active"
                                v-model="active">
                                    <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="true">{{ $t("lbl.basic.yes") }}</option>
                                    <option value="false">{{ $t("lbl.basic.no") }}</option>
                                </select>
                                <span v-show="errors.has('active')" class="lbl-obg">
                                    {{ errors.first('active') }}
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-8">
                                <label class="control-label">{{$t('lbl.basic.description')}}:</label>
                                <b-textarea 
                                :rows="3"
                                :max-rows="6"
                                v-model="description">
                                </b-textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6" v-show='showValueInput'>
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.value')}}:</label>
                                <input class="form-control form-control-sm" 
                                v-model="value" type="text"/>

                            </div>

                            <div class="form-group col-md-2" v-show='showValueBoolean'>
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.value')}}:</label>
                                <select class="form-control" v-model="value">
                                    <option value="true">{{ $t("lbl.basic.yes") }}</option>
                                    <option value="false">{{ $t("lbl.basic.no") }}</option>
                                </select>
                            </div>

                            <div class="form-group col-md-12" v-show='showValueEditor'>
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.value')}}:</label>
                                <codemirror 
                                v-model="value" 
                                name="value"
                                v-validate="'required'"
                                ref="myCm"
                                :options="cmOptions">
                                </codemirror>
                                
                                <span v-show="errors.has('value')" class="lbl-obg">
                                    {{ errors.first('value') }}
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
 </template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 340px; 
}
</style>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from "vuex";
import {fields} from "@/model/adm/SystemParameters";


import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/mode/properties/properties.js'
//import 'codemirror/theme/base16-dark.css'
import 'codemirror/theme/eclipse.css'

const { mapFields } = createHelpers({
  getterType: 'systemParameters/getField',
  mutationType: 'systemParameters/updateField',
});
export default {
  data () {
    return {
      cmOptions: {
        tabSize: 4,
        mode: 'text/plain',
        theme: 'eclipse',
        lineNumbers: true,
        line: true,
      }
    }
  },
  mounted(){
      this.changeEditor();
  },
  computed: {
    ...mapFields(fields),
    showValueEditor () {
        return this.$store.state.systemParameters.showValueEditor
    },
    showValueInput () {
        return this.$store.state.systemParameters.showValueInput
    },
    showValueBoolean () {
        return this.$store.state.systemParameters.showValueBoolean
    }
  },
  methods: {
    //...mapActions("systemParameters", ["changeEditor"]),
    ...mapActions("base", ["MMFbackToList", "MMFSave"]),
    changeEditor(){
        var dtType = this.$store.state.systemParameters.entity.dataType;
        var me = this;

        var toogleEditor = function(){
            me.$store.commit('systemParameters/toggleShowValueEditor', true);
            me.$store.commit('systemParameters/toggleShowValueInput', false);
            me.$store.commit('systemParameters/toggleShowValueBoolean', false);
        }
        var toogleInput = function(){
            me.$store.commit('systemParameters/toggleShowValueEditor', false);
            me.$store.commit('systemParameters/toggleShowValueInput', true);
            me.$store.commit('systemParameters/toggleShowValueBoolean', false);
        }
        var toogleBoolean = function(){
            me.$store.commit('systemParameters/toggleShowValueEditor', false);
            me.$store.commit('systemParameters/toggleShowValueInput', false);
            me.$store.commit('systemParameters/toggleShowValueBoolean', true);
        }

        switch (dtType) {
            case 'X':
                toogleEditor();
                this.$refs.myCm.codemirror.setOption("mode", 'text/xml');
            break;
            case 'J':
                toogleEditor();
                this.$refs.myCm.codemirror.setOption("mode", 'text/javascript');
            break;
            case 'Y':
                toogleEditor();
                this.$refs.myCm.codemirror.setOption("mode", 'text/yaml');
            break;
            case 'P':
                toogleEditor();
                this.$refs.myCm.codemirror.setOption("mode", 'text/x-properties');
            break;
            default:
                toogleEditor();
                this.$refs.myCm.codemirror.setOption("mode", 'text/plain');
            break;
            case 'N': case 'D' : case 'U':
                toogleInput();
            break;
            case 'B':
                toogleBoolean();
            break;
        }
    },
    validateForm () {
        this.$validator.validateAll().then(isValid => {
            if( isValid ){
                this.$store.dispatch('base/MMFSave', 'systemParameters');
            }
        });
    }
  },
  components: {
    codemirror
  }
};
</script>